'use strict'

import axios from 'axios'
import router from 'router'
import { MessageBox } from 'element-ui'
import { LOCAL_KEY_CURRENT_LANGUAGE } from '../constants/StorageKeys'
import { LanguageEnum } from 'utils/LanguageEnum'

// 创建axios实例
const httpService = axios.create({
  /*eslint-disable */
  baseURL: process.env.BASE_URL,
  timeout: 60 * 60 * 1000,
  headers: {
    'Content-Type': 'application/json',
    'JY-ENVIRONMENT': process.env.ENV_NAME
  }
})

// http请求拦截器
httpService.interceptors.request.use(function(config) {
  const userToken = JSON.parse(sessionStorage.getItem('SESSION_KEY_USER'))
      && JSON.parse(sessionStorage.getItem('SESSION_KEY_USER')).token

  // 登录不需要传token
  if (userToken && !config.url.endsWith('login')) {
   config.headers.common['SIMPLANTING_TOKEN'] = userToken
   config.headers.common['PDS-ESP-APP-TOKEN'] = userToken
  }
  if (config.method === 'get') {
    //  给data赋值以绕过if判断
    config.data = true 
  }
  //config.headers['Content-Type'] = 'application/json'
  config.headers.common['SIMPLANTING-FRONTEND-LANG'] = (window[LOCAL_KEY_CURRENT_LANGUAGE] === LanguageEnum.CHINESE ? 'cn' : 'en')
  return config
}, function(err) {
  console.log('httpService.interceptors.request err:', err)
  Promise.reject(err)
})

// 请求响应拦截器
httpService.interceptors.response.use(function(res) {
  const ERRNO = Number(res.resCode || 0)
  if (ERRNO == 0) {
    return res
  }

  // token 失效，引导用户重新登录
  if (ERRNO == 1234567) {
    MessageBox.confirm('你已被登出，请重新登录', '确定登出', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      router.replace({ path: '/login' })
    })
    return Promise.reject('error')
  }
}, (error) => {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break;
      case 401:
        error.message = '未授权，请重新登录'
        break;
      case 403:
        error.message = '拒绝访问'
        break;
      case 404:
        error.message = '请求错误,未找到该资源'
        break;
      case 405:
        error.message = '请求方法未允许'
        break;
      case 408:
        error.message = '请求超时'
        break;
      case 500:
        error.message = '服务器端出错'
        break;
      case 501:
        error.message = '网络未实现'
        break;
      case 502:
        error.message = '网络错误'
        break;
      case 503:
        error.message = '服务不可用'
        break;
      case 504:
        error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    error.message = "连接到服务器失败，请稍后重试"
  }

  return Promise.reject(error)
})

// 封装 post 请求
export const postRequest = (url, data, params) => {
  return httpService(Object.assign({
    method: 'post',
    url: url,
    data: data || {}
  }, params || {}))
  .then(res => res.data)
}

// 封装 get 请求
export const getRequest = (url, params, responseType) => {
  return httpService({
    method: 'get',
    url: url,
    params: params || {},
    responseType: responseType || '',
  })
  .then(res => res.data)
}

// 封装 put 请求
export const putRequest = (url, params) => {
  return httpService({
    method: 'put',
    url: url,
    data: params || {}
  })
  .then(res => res.data)
}

// 封装 delete 请求
export const deleteRequest = (url, params) => {
  return httpService({
    method: 'delete',
    url: url,
    data: params || {}
  })
  .then(res => res.data)
}


// WEBPACK FOOTER //
// ./src/utils/http-service.js